import Vue from 'vue';
import { isValidArray } from '@razlet/utils';
import CapacityTrunkDimensions from './capacity-trunk-dimensions';

const OVERLOAD_CODES = ['dp_small'];

const UNDERLOAD_CODES = ['dp_big'];

export default class Capacity {
  data = null;

  trunkDimensions = null;

  constructor (data) {
    this.data = data;
    this.trunkDimensions = new CapacityTrunkDimensions(data.trunkDimensions);
  }

  get id () {
    return this.data.id;
  }

  get airplane () {
    return this.data.iataAirplane;
  }

  get airplanes () {
    return this.data.airplanes.map(item => item.number);
  }

  get airplanesId () {
    return this.data.airplanes.map(item => item.id);
  }

  get code () {
    return this.data.code;
  }

  get isOverloadCode () {
    return OVERLOAD_CODES.includes(this.code);
  }

  get isUnderloadCode () {
    return UNDERLOAD_CODES.includes(this.code);
  }

  get iata () {
    return this.data.iataCompany;
  }

  get mtow () {
    return this.data.mtow;
  }

  get paxCount () {
    return this.data.paxCapacity;
  }

  get payload () {
    return this.data.payload;
  }

  get payloadVolume () {
    return this.data.trunkMaxVolumeWithStowageFactor;
  }

  get maxCarrierVolume () {
    return this.data.maxCarrierVolume;
  }

  get maxCarrierWeight () {
    return this.data.maxCarrierWeight;
  }

  get trunkMaxHeight () {
    return this.data.trunkMaxHeight;
  }

  get trunkMaxWidth () {
    return this.data.trunkMaxWidth;
  }

  get trunkMaxLength () {
    return this.data.trunkMaxLength;
  }

  get trunkMaxVolume () {
    return this.data.trunkMaxVolume;
  }

  get trunkMaxWeight () {
    return this.data.trunkMaxWeight;
  }

  get shortName () {
    // eslint-disable-next-line vue/max-len
    return `${this.airplane} | ${this.maxCarrierWeight}${Vue.prototype.$localize.t('base.kg')}; ${this.maxCarrierVolume}${Vue.prototype.$localize.t('base.m3')}`;
  }

  get fullName () {
    // eslint-disable-next-line vue/max-len
    return `${this.airplane} | ${this.airplanes.join(', ')} | ${this.maxCarrierWeight}${Vue.prototype.$localize.t('base.kg')}; ${this.maxCarrierVolume}${Vue.prototype.$localize.t('base.m3')}`;
  }

  get trunkDimensionsTablesData () {
    return this.trunkDimensions.tablesData;
  }

  get hasTrunkDimensions () {
    return isValidArray(this.trunkDimensionsTablesData);
  }

  get trunkDimensionsMeasurementUnit () {
    return this.trunkDimensions.measurementUnit;
  }

  set trunkDimensionsMeasurementUnit (value) {
    this.trunkDimensions.measurementUnit = value;
  }

  get abilityProps () {
    return { company: this.iata };
  }
};
